import React from 'react'
import { BrowserRouter, Route, Navigate,Routes } from "react-router-dom";
import { useSelector ,} from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {UserLogin,Logout, Question, CustomerEdit,AppLayout,AdminDashboard, Orders,OrderDetails,Customers,
  Sales,Notifications,Feedbacks,Staff,NewStaff, Products,ProductEdit
  ,NewProduct ,Profile, Categories, NewCategory, CategoryEdit,
  Coupons, NewCoupon, CouponEdit, Banners, NewBanner, BannerEdit,
  ActivityLog, Settings } from "./adminExportFiles";
import { ToastProvider, ConfirmProvider } from "./components/ui";

// Matches the admin design system's accent token (--admin-accent) - any
// MUI-styled element still in the tree (icons, remaining Alert/CircularProgress
// usage pre-migration) should read as part of the same product, not the
// old pink brand this admin panel started from.
const theme = createTheme({
  palette: {
    primary: {
      main: '#5b3ff2',
      dark: '#4c31d6',
    },
  },
});

const STAFF_TYPES = ['ADMIN', 'STAFF'];

function App() {
  const {access_token} = useSelector(state => state.auth);
  const {type} = useSelector(state => state.user);
  const isStaffOrAdmin = Boolean(access_token) && STAFF_TYPES.includes(type);
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
      <ConfirmProvider>
      <BrowserRouter>
        <Routes>
          <Route path="logout" element={<Logout /> } />
          <Route  path="login" element={ <UserLogin /> } />
          {/* admin routes - this panel is staff/admin only, not for CUSTOMER accounts */}
          <Route path="admin" element={isStaffOrAdmin ? < AppLayout/>  : <Navigate to="/login" />} >
            <Route index path="dashboard" element={ <AdminDashboard />}/>
            <Route path="customers" element={<Customers />} />
            <Route path="customer/edit/:id" element={<CustomerEdit />} />
            <Route path="orders" element={<Orders />} />
            <Route path="order/details/:id" element={<OrderDetails/>} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="question" element={<Question />} />
            <Route path="feedbacks" element={<Feedbacks />} />
            <Route path="products" element={<Products />} />
            <Route path="product/new" element={<NewProduct />} />
            <Route path="product/edit/:id" element={<ProductEdit />} />
            <Route path="categories" element={<Categories />} />
            <Route path="category/new" element={<NewCategory />} />
            <Route path="category/edit/:id" element={<CategoryEdit />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="coupon/new" element={<NewCoupon />} />
            <Route path="coupon/edit/:id" element={<CouponEdit />} />
            <Route path="banners" element={<Banners />} />
            <Route path="banner/new" element={<NewBanner />} />
            <Route path="banner/edit/:id" element={<BannerEdit />} />
            <Route path="activity-log" element={<ActivityLog />} />
            <Route path="settings" element={<Settings />} />
            <Route path="profile" element={<Profile />} />
            <Route path="sales" element={<Sales />} />
            <Route path="staff" element={<Staff/>} />
            <Route path="staff/edit/:id" element={<CustomerEdit />} />
            <Route path="newstaff" element={<NewStaff/>} />
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
      </ConfirmProvider>
      </ToastProvider>
      </ThemeProvider>
  );
}
    
export default App;
